import { render, staticRenderFns } from "./exp_M_traslado_XM.vue?vue&type=template&id=02b796a1"
import script from "./exp_M_traslado_XM.vue?vue&type=script&lang=js"
export * from "./exp_M_traslado_XM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports